import styled from "styled-components";

export const LogoStyled = styled.img`
  width: ${props => props.width || '15.47vw'}; 
  height: ${props => props.height || '8.055vh'};
  object-fit: contain;
`;